import PropTypes from 'prop-types';
import styled from 'styled-components';

import { Box } from '@hivebrite/design-system/Box';

import Ticket from './components/Ticket';

const TicketTable = ({ tickets = [], maxTicketsPerUser }) => {
  if (!tickets.length) {
    return null;
  }

  return (
    <div data-testid="ticket-table">
      <Title as="h2" mb={3} font="h3-semibold">
        {s__('NetworkEvents|Available Tickets')}
      </Title>
      {maxTicketsPerUser ? (
        <Box font="body-dove-italic" mt={3} pb={4}>
          {I18n.t(
            'web.networks.events.attendees.reach_max_tickets_per_user.title',
            {
              number: maxTicketsPerUser,
            },
          )}
        </Box>
      ) : null}
      {tickets.map((ticket, index) => (
        <Row py={3} key={ticket.id} hasBorder={index + 1 < tickets.length}>
          <Ticket ticket={ticket} index={index} />
        </Row>
      ))}
    </div>
  );
};

TicketTable.propTypes = {
  tickets: PropTypes.array,
  maxTicketsPerUser: PropTypes.number,
};

export default TicketTable;

const Title = styled(Box)`
  padding-bottom: ${(props) => props.theme.space[3]}px;
  border-bottom: 1px solid ${(props) => props.theme.colors.horizon};
`;

const Row = styled(Box).withConfig({
  shouldForwardProp: (prop) => !['hasBorder'].includes(prop),
})`
  ${({ hasBorder, theme }) =>
    hasBorder && `border-bottom: 1px solid ${theme.colors.horizon}`};
`;
